module.exports = __webpack_public_path__ + "media/videos/video-main-2fc88193a2c9dba21dcadca69a0cf2c0.ogv";